<template lang="pug">
  sui-grid
    sui-grid-row
      sui-grid-column
        highcharts(:options="options")
</template>

<script>
export default {
  name: 'CompareChart',
  props: {
    ratio: {
      default: false,
    },
    statTypes: {
      required: true,
    },
    stats: {
      required: true,
    },
    teams: {
      required: true,
    },
  },
  data() {
    return {
      baseOptions: {
        chart: {
          type: 'bar',
        },
        title: {
          text: 'Player Stats',
        },
        xAxis: {
          categories: [],
          title: {
            text: 'Gamertags',
          },
        },
        yAxis: {
          title: {
            text: `${this.ratio ? 'Ratio' : 'Value'}`,
            align: 'high',
          },
          labels: {
            overflow: 'justify',
          },
        },
        plotOptions: {
          bar: {
            dataLabels: {
              enabled: true,
            },
          },
        },
        legend: {},
        credits: {
          enabled: true,
        },
        series: [],
      },
    };
  },
  computed: {
    statType() {
      return this.statTypes.find(x => x.key === 'eliminations');
    },
    options() {
      const stats = this.stats
        .reduce(
          (a, s, i) =>
            a.concat(
              s.map(x => ({
                ...x,
                color: this.teams[i].colors.primary.color,
              })),
            ),
          [],
        )
        .sort((a, b) => b.stats[this.statType.key] - a.stats[this.statType.key]);

      return {
        ...this.baseOptions,
        xAxis: {
          ...this.baseOptions.xAxis,
          categories: stats.map(s => s.info.gamertag),
        },
        series: [
          {
            name: `${this.statType.longName}${this.ratio ? ' Ratio' : ''}`,
            data: stats.map(s => ({
              color: s.color,
              y: this.ratio
                ? this.normalize(s.stats[this.statType.key])
                : s.stats[this.statType.key],
            })),
          },
        ],
      };
    },
  },
  methods: {
    normalize(value) {
      const { best, worst } = this.statType;
      const beforeRound = (value - worst) / (best - worst);
      return Math.round(beforeRound * 100) / 100;
    },
  },
};
</script>
